export default __webpack_public_path__ + "static/ore-offer-2f48e1ead3f54bffb48d6a29fce406af.png";